
export default [
    
    {
        path: '/',
        redirect: '/weatherForecast'
    },
    // {
    //     path: '/scenicSpotWeather',
    //     name: 'scenicSpotWeather',
    //     meta:{
    //         title:'景点天气'
    //     },
    //     component: () => import('../views/ScenicSpotWeather/ScenicSpotWeather.vue')
    // },
    // {
    //     meta:{
    //         title:'实况监测'
    //     },
    //     path: '/liveMonitoring',
    //     name: 'liveMonitoring',
    //     component: () => import('../views/LiveMonitoring/LiveMonitoring.vue')
    // },
    {
        path: '/weatherForecast',
        name: 'weatherForecast',
        meta:{
            title:'天气预报'
        },
        component: () => import('../views/WeatherForecast/WeatherForecast.vue')
    },
    {
        path: '/oceanServices',
        name: 'oceanServices',
        meta:{
            title:'海洋服务'
        },
        component: () => import('../views/OceanServices/OceanServices.vue')
    },
    {
        path: '/radarSatellite',
        name: 'radarSatellite',
        meta:{
            title:'雷达卫星'
        },
        component: () => import('../views/RadarSatellite/RadarSatellite.vue')
    },
    {
        path: '/earlyWarning',
        name: 'earlyWarning',
        meta:{
            title:'预警订制'
        },
        component: () => import('../views/EarlyWarning/EarlyWarning.vue')
    },
    {
        path: '/login',
        name: 'login',
        meta:{
            title:'登录授权'
        },
        component: () => import('../views/Login/Login.vue')
    },
    {
        path: '/weatherVideo',
        name: 'weatherVideo',
        meta:{
            title:'气象视频'
        },
        component: () => import('../views/WeatherVideo/WeatherVideo.vue')
    },
      
]


// WEBPACK FOOTER //
// ./src/router/route.js